import { Box } from "@mui/material";
import {
  GridColDef,
  GridPagination,
  GridSlotsComponentsProps,
} from "@mui/x-data-grid";
import ExcelExportButton from "./ExcelExportButton";

export interface DataTableFooterProps {
  columns: GridColDef[];
  rows: any[];
}

const DataTableFooter: React.FC<
  DataTableFooterProps & GridSlotsComponentsProps
> = ({ rows, columns }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderTop: "1px solid rgba(224, 224, 224, 1)",
      }}
    >
      <GridPagination />
      <ExcelExportButton rows={rows} columns={columns} />
    </Box>
  );
};

export default DataTableFooter;
